<div class="loading" *ngIf="loading == true">Loading&#8230;</div>
<div id="endorsed-users" class="endorsed-users">
    <mat-card>
        <h3>Endorsed Users</h3>
        <div class="row-container pt-1 pb-1">
            <div class="col-12">
                <div class="documents-table-container">
                    <span class="paragraph bold user-heading">Planners</span>
                    <div class="row">
                        <div class="col-12">
                            <div class="search-wrapper hidden">
                                <mat-icon>search</mat-icon>
                                <input type="text" placeholder="Search" class="search-input"
                                    (input)="applyFilter($event)" />
                            </div>
                            <app-data-table [data]="dataUrbanPlanner" [columns]="columns"
                                [actionOptions]="actionOptions"></app-data-table>
                        </div>
                    </div>
                </div>
            </div>
            <br><br>
            <div class="col-12">
                <div class="documents-table-container">
                    <span class="paragraph bold user-heading">Agents</span>
                    <div class="row">
                        <div class="col-12">
                            <div class="search-wrapper hidden">
                                <mat-icon>search</mat-icon>
                                <input type="text" placeholder="Search" class="search-input"
                                    (input)="applyFilterAgent($event)" />
                            </div>
                            <app-data-table [data]="dataAgent" [columns]="columns"
                                [actionOptions]="actionOptions"></app-data-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </mat-card>
</div>
